import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { GtmService } from '../../../core/tracking/gtm.service';
import { BtnComponent } from '../buttons/btn/btn.component';

/**
 * Bandeau de consentement des pages de connexion et d'inscription (MOKA-319). Google Tag Manager
 * n'est chargé qu'après « Accepter » ; « Refuser » est aussi visible et aussi simple (CNIL).
 * Choix mémorisé 6 mois, modifiable par « Gérer les cookies » en pied de page.
 */
@Component({
  selector: 'app-consent-banner',
  imports: [RouterLink, BtnComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './consent-banner.component.scss',
  template: `
    @if (gtm.bannerVisible()) {
      <section class="consent" role="region" aria-label="Consentement aux cookies de mesure d'audience">
        <p class="consent__text">
          Nous avons besoin de cookies et de technologies similaires pour que notre site web fonctionne
          correctement. Nous n'utilisons des cookies supplémentaires que si vous les acceptez. Ceux-ci nous
          aident à améliorer nos performances et votre expérience.
          <a routerLink="/documents/privacy-policy">En savoir plus</a>
        </p>
        <div class="consent__actions">
          <app-btn [config]="{ type: 'outline', color: 'coffee' }" (click)="gtm.refuse()">Refuser</app-btn>
          <app-btn [config]="{ type: 'filled', color: 'coffee' }" (click)="gtm.accept()">Accepter</app-btn>
        </div>
      </section>
    }
  `,
})
export class ConsentBannerComponent {
  protected readonly gtm = inject(GtmService);
}
